module.exports = __webpack_public_path__ + "img/309.f3b07388.png";